import React from 'react';
import { CheckCircle, Info } from 'lucide-react';

export default function SubmittedStage({ aiOrderNumber, poNumber, alreadySubmitted, onReset }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-6">
      <div className="text-center">
        <div className="w-24 h-24 mx-auto mb-6 bg-emerald-500 rounded-full flex items-center justify-center animate-bounce">
          <CheckCircle className="w-12 h-12 text-white" />
        </div>
        <h2 className="text-3xl font-bold text-white mb-2">Order Submitted!</h2>
        <p className="text-emerald-400 font-mono text-lg mb-2">
          Your Order {aiOrderNumber} has been sent to A+
        </p>
        {alreadySubmitted && (
          <p className="max-w-md mx-auto mb-2 px-4 py-2 rounded-lg bg-sky-500/10 text-sky-300 text-sm flex items-start gap-2 text-left">
            <Info className="w-4 h-4 mt-0.5 flex-shrink-0" />
            <span>This order had already been submitted, so it wasn't sent again. There is no duplicate in A+.</span>
          </p>
        )}
        {poNumber && (
          <p className="text-slate-400 text-sm mb-8">PO: {poNumber}</p>
        )}
        <button
          onClick={onReset}
          className="px-6 py-3 bg-slate-700 hover:bg-slate-600 text-white rounded-lg transition-colors"
        >
          Process Another Order
        </button>
      </div>
    </div>
  );
}
